import React, { useState, useEffect, useRef } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import Upload from '../../../../components/Input/Upload';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import LayoutContext from '../../../../store/Layout/contexts';
import { newFetch, PUT, GET, DELETE } from '../../../../helpers/fetch';
import AppContext from '../../../../store/App/contexts';

const EditCatalogue = ({
  history,
  match: {
    params: { catalogue_id },
  },
}) => {
  const type = localStorage.getItem('type');
  const {
    fetchClientsOptions,
    client_options,
    selectedClientID,
    clientFilterHandler,
  } = React.useContext(AppContext);
  const [catalogue, setCatalogue] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [client, setClient] = useState('');
  const [status, setStatus] = useState(0);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [howToSetup, setHowToSetup] = useState('');
  const [stock, setStock] = useState('');
  const [uploads, setUploads] = useState([]);
  const [origClient, setOrigClient] = useState('');
  const [clientName, setClientName] = useState('');

  const fetchStatusOptions = async () => {
    let api_path = `/fields/catalogue_status`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatusOptions(response.data);
    }
  };

  const fetchCatalogue = async () => {
    let api_path = `/catalogue/${catalogue_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let responseData = response.data;
      setCatalogue(responseData);
      setName(responseData.name);
      setDescription(responseData.description);
      setStatus(responseData.status);
      setHowToSetup(responseData.how_to_setup);
      setStock(responseData.stock);
      setUploads(responseData.images);
      setClient(responseData.client_id);
      setOrigClient(responseData.client_id);
      setClientName(
        client_options &&
          client_options.find((clnt) => clnt.id === responseData.client_id)
            ?.name
      );
    }
  };

  const validateForm = () => {
    if (!client || client == 0) {
      ToastUtil.error('Please select a Client!');
      return false;
    }

    if (!name) {
      ToastUtil.error('Please input Name!');
      return false;
    }

    if (uploads.length <= 0) {
      ToastUtil.error('Please insert Images to Upload!');
      return false;
    }

    return true;
  };

  const HandleSubmitUpdate = async (e) => {
    e.preventDefault();
    let addtnl_message = ``;

    if (selectedClientID != 0 && origClient !== parseInt(selectedClientID))
      addtnl_message = `Client has been updated. `;

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        `${addtnl_message}Are you sure you want to update this Catalogue?`
      ))
    ) {
      let formData = new FormData();

      formData.append('client_id', client);
      formData.append('status', status);
      formData.append('name', name);
      formData.append('stock', stock);
      formData.append('description', description);
      formData.append('how_to_setup', howToSetup);

      uploads.map((file, index) => {
        if (file instanceof File) {
          formData.append('files[]', file);
          formData.append('filesSort[]', index);
        } else {
          formData.append(
            'filesToUpdate[]',
            JSON.stringify({ ...file, sort: index })
          );
          formData.append('filesToUpdateIds[]', file.id);
        }
      });

      let api_path = `/catalogue/${catalogue_id}`;
      let response = await newFetch(PUT, api_path, formData, 'multi');

      ToastUtil.success(response.message);

      if (response.success) {
        history.push(`/catalogue`);
      }
    }
  };

  const handleDiscard = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setStatus(catalogue.status || 0);
      setName(catalogue.name || '');
      setDescription(catalogue.description || '');
      setHowToSetup(catalogue.howToSetup || '');
    }
  };

  const handleDeleteCatalogue = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Catalogue?'
      )
    ) {
      let api_path = `/catalogue/${catalogue_id}`;
      let response = await newFetch(DELETE, api_path);

      ToastUtil.success(response.message);

      response.success && history.push(`/catalogue`);
    }
  };

  useEffect(() => {
    fetchCatalogue();
    fetchClientsOptions(type);
    fetchStatusOptions();
  }, []);

  useEffect(() => {
    if (client_options && !clientName) {
      setClient(selectedClientID);
      setClientName(
        client_options &&
          client_options.find((clnt) => clnt.id === parseInt(selectedClientID))
            ?.name
      );
    }
  }, [client_options]);

  useEffect(() => {
    if (client != selectedClientID) {
      setClient(selectedClientID);
      setClientName(
        client_options &&
          client_options.find((clnt) => clnt.id === parseInt(selectedClientID))
            ?.name
      );
    }
  }, [selectedClientID]);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to={`/catalogue`}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to Catalogue
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Edit Catalogue</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => HandleSubmitUpdate(e)}>
              <div
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded">
                  <div
                    className="flex-grow-1 bg-white col-md-7"
                    style={{ padding: '2.25rem' }}
                  >
                    <div
                      className="row pb-3 col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Client</strong>
                      <p className="text-muted fs-5">{client && clientName}</p>
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Status</strong>
                      <select
                        name="status"
                        className="form-control mt-3 adjust-fs"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value={0}>Select Status</option>
                        {statusOptions &&
                          statusOptions.map((status, index) => (
                            <option
                              key={`${status.id}_${index}`}
                              value={status.id}
                            >
                              {status.label}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Name*</strong>
                      <input
                        type="text"
                        className="form-control mt-3 adjust-fs"
                        placeholder="Name"
                        value={name}
                        onChange={({ target: { value } }) => setName(value)}
                      />
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Stock</strong>
                      <input
                        type="number"
                        className="form-control mt-3 adjust-fs"
                        placeholder="Stock"
                        value={stock || 0}
                        onChange={({ target: { value } }) => setStock(value)}
                      />
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>Description</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        placeholder="Description"
                        value={description}
                        onChange={({ target: { value } }) =>
                          setDescription(value)
                        }
                      />
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>How to Setup</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        placeholder="How to Setup"
                        value={howToSetup}
                        onChange={({ target: { value } }) =>
                          setHowToSetup(value)
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="flex-grow-1 bg-white col-md-5"
                    style={{ paddingTop: '2.25rem' }}
                  >
                    <div className="row pb-3 col-md-12">
                      <div className="col-12">
                        <strong>Images</strong>
                      </div>
                      <div className="pt-3 col-12">
                        {uploads && (
                          <Upload
                            files={uploads}
                            setFiles={setUploads}
                            multiple={true}
                            accept={'image/*'}
                            sort={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-between"
              >
                <button
                  type="button"
                  className="btn btn-danger adjust-fs adjust-shadow ms-4"
                  style={{ width: '12rem' }}
                  onClick={handleDeleteCatalogue}
                >
                  Delete
                </button>
                <div className="d-flex flex-row">
                  <button
                    type="button"
                    className="btn btn-outline-brand adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                    onClick={handleDiscard}
                  >
                    Discard
                  </button>
                  <button
                    type="submit"
                    className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Save changes
                  </button>
                </div>
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditCatalogue);
